export const MAP_STYLES = [
  { key: 'streets-v12', label: 'Streets', value: 'mapbox://styles/mapbox/streets-v12' },
  { key: 'outdoors-v12', label: 'Outdoors', value: 'mapbox://styles/mapbox/outdoors-v12' },
  { key: 'light-v11', label: 'Light', value: 'mapbox://styles/mapbox/light-v11' },
  { key: 'dark-v11', label: 'Dark', value: 'mapbox://styles/mapbox/dark-v11' },
  { key: 'satellite-v9', label: 'Satellite', value: 'mapbox://styles/mapbox/satellite-v9' },
  {
    key: 'satellite-streets-v12',
    label: 'Satellite Streets',
    value: 'mapbox://styles/mapbox/satellite-streets-v12'
  },
  {
    key: 'navigation-day-v1',
    label: 'Navigation Day',
    value: 'mapbox://styles/mapbox/navigation-day-v1'
  },
  {
    key: 'navigation-night-v1',
    label: 'Navigation Night',
    value: 'mapbox://styles/mapbox/navigation-night-v1'
  }
];

export const SWITZERLAND_CENTER = [8.2275, 46.8182];
